import { showToast } from "vant";
import i18n from "@/language";
import router from "@/routers";
import msg from "@/language/locales/en-US/msg";
const i18nGlobal = i18n.global as any;
import { useGlobalStore } from "@/stores/modules/global";

/**
 * 默认存放需要操作的，提示类的使用 `@/language/locales/en-US/msg.status`
 */
const errorMap = new Map<number, { text?: string; route?: string }>([
	[
		10030018,
		{
			route: "/deposit"
		}
	]
]);

/**
 * 初始化错误代码
 */
const initStatus = () => {
	const statusData: Record<number, string> = msg.status;
	for (const item in statusData) {
		const info = errorMap.get(Number(item));
		errorMap.set(Number(item), {
			...info
		});
	}
};
initStatus();

/**
 * 格式化消息模板，支持：
 * - 位置参数：{0}, {1}...（传数组）
 */
export function formatMessage(message: string, args?: any[]) {
	if (!message || !args || !args?.length) return message || "";

	if (Array.isArray(args) && args?.length) {
		// 处理数组参数：{0}, {1}, ...
		return message.replace(/\{(\d+)\}/g, (match, index) => {
			const val = args[Number(index)];
			return val !== undefined ? String(val) : match;
		});
	}

	// 如果 args 不是数组原样返回字符串
	return message;
}

/**
 * @description: 校验网络请求状态码
 * @param {Number} status
 * @return void
 */
export const checkStatus = async (status: number, msg?: string, msgVars: any[] = []) => {
	const info = errorMap.get(status);
	const globalStore = useGlobalStore();
	const errorCodes = globalStore.errorCodesGet ?? [];
	const errorCode = errorCodes.find((item: any) => item.code === status);
	if (errorCode?.message) {
		showToast(formatMessage(errorCode?.message, msgVars));
	} else if (info?.route) {
		router.push(info.route);
	} else {
		if (errorMap.has(status)) {
			showToast(i18nGlobal.t(`msg.status.${status}`, msgVars) ?? msg);
		} else {
			showToast(msg ?? errorMap.get(500)?.text);
		}
	}
};
